import type { GovernanceFinding, GovernanceOverview } from '../types/governance'
import { fetchApi } from './api'

/**
 * The Governance Queue — ObservatoryGovernanceController, LighthouseAdmin at class
 * level, GET only.
 *
 * ALWAYS ONE GROUP PER REQUEST, and there is deliberately no unfiltered call here.
 * Four groups — expiring, lapsed, reach and inactive — read columns added by
 * migration AddGrantExpiryAndNotes, which is applied to local dev only. The
 * unfiltered request computes all six in one action, so in Staging and Production
 * one missing column 500s the whole response and the two groups that would have
 * answered (ownership, schedules) are lost with it (controller class remarks,
 * "Three columns it reads exist only in local dev"). One request per group keeps a
 * failure where it belongs.
 *
 * Through the shared `fetchApi`, so a failure arrives as an ApiError carrying its
 * status: a section can tell a 403 (RestrictedState) from a 500 (the migration)
 * from a list that is genuinely empty, and it can only do that by status.
 */
export function getGovernanceFinding(finding: GovernanceFinding): Promise<GovernanceOverview> {
  return fetchApi<GovernanceOverview>(`/api/observatory/governance?finding=${encodeURIComponent(finding)}`)
}
